module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.onMobile) ? _c('div', [(!_vm.videoUploaded) ? _c('div', [_c('BannerUpload', {
    attrs: {
      "MainHeading": "Spotlight video",
      "MainText": "Upload a 15 second video clip to attract new followers when new potential subscribers preview your content",
      "Icon": _vm.iconImage,
      "MainImage": _vm.bannerImage
    }
  }), _vm._v(" "), _c('drag-file-uploader', {
    ref: "dragFileUploader",
    attrs: {
      "accept": "video/*",
      "type": "file",
      "category": "video",
      "autoUpload": true
    },
    on: {
      "filePicked": _vm.pickedFile
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "spotlight-header dflex align-center justify-space-between"
  }, [_c('div', {
    staticClass: "replace",
    on: {
      "click": function($event) {
        _vm.replaceVideo()
      }
    }
  }, [_vm._v("\n\t\t\t\t< Replace video\n\t\t\t")]), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "head-button",
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("\n\t\t\t\t\tSave video\n\t\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "main-flex"
  }, [_c('div', {
    staticClass: "w-75"
  }, [_c('h2', {
    staticClass: "heading"
  }, [_vm._v("Web Preview")]), _vm._v(" "), _c('div', {
    staticClass: "web-container"
  }, [_c('div', {
    staticClass: "web-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "_user-icon mb-4"
  }, [_c('div', {
    staticClass: "user-icon-inner",
    style: ({
      'background-image': 'url(' + _vm.currentUser.avatar.url + ')'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "_info mb-4"
  }, [_c('p', [_vm._v("Subscribe to support")]), _vm._v(" "), _c('div', {
    staticClass: "dflex align-center"
  }, [_c('p', {
    staticClass: "font-bold mr-1"
  }, [_vm._v(" " + _vm._s(_vm.currentUser.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/check_success.svg"),
      "width": "12"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_text mb-4"
  }, [_vm._v("\n\t\t\t\t\t\t\tGet full access to all creators and their content. 50% of your subscription shared with creators that viewed the most.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "_button"
  }, [_c('v-btn', {
    staticClass: "button-web",
    attrs: {
      "rounded": ""
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tSubscribe\n\t\t\t\t\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "web-video"
  }, [_c('div', {
    staticClass: "modal-card-title-img"
  }, [_c('video', {
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "loop": "",
      "id": "bgvid"
    }
  }, [_c('source', {
    attrs: {
      "src": this.video.src,
      "type": this.videoFile[0].type
    }
  })]), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "w-25"
  }, [_c('h2', {
    staticClass: "heading"
  }, [_vm._v("Mobile Preview")]), _vm._v(" "), _c('div', {
    staticClass: "mob-container"
  }, [_c('div', {
    staticClass: "mob-video"
  }, [_c('div', {
    staticClass: "modal-card-title-img"
  }, [_c('video', {
    staticClass: "min-height",
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "muted": "",
      "loop": "",
      "id": "bgvid"
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": this.video.src,
      "type": this.videoFile[0].type
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "mob-content"
  }, [_c('div', {
    staticClass: "_info"
  }, [_c('p', [_vm._v("Subscribe to support")]), _vm._v(" "), _c('div', {
    staticClass: "dflex align-center"
  }, [_c('p', {
    staticClass: "font-bold mr-1"
  }, [_vm._v(" " + _vm._s(_vm.currentUser.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/check_success.svg"),
      "width": "12"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "_text mb-3"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tGet full access to all creators and their content. 50% of your subscription shared with creators that viewed the most.\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "_button"
  }, [_c('v-btn', {
    staticClass: "button-mob"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tStart 30 day free trial\n\t\t\t\t\t\t\t\t")])], 1)])])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-image-section"
  }, [_c('div', {
    staticClass: "profile-image"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/nav_logo_white.png"),
      "width": "140"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "volume-button"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/mute-icon.svg"),
      "width": "17px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_logo mb-3"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/ys_logo_primary-black.svg"),
      "width": "70"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6746527c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/spotlight/index.vue
// module id = 1755
// module chunks = 180